import { render, staticRenderFns } from "./UserValidation.vue?vue&type=template&id=4d96e646&"
import script from "./UserValidation.vue?vue&type=script&lang=js&"
export * from "./UserValidation.vue?vue&type=script&lang=js&"
import style0 from "./UserValidation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserValidation.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VFlex,
  VImg,
  VLayout,
})
